import { makeApiCall, processApiValues } from '../../../helpers/utils';

export const getWatchlist = async (userId) => {
  const formattedUserId = userId.startsWith('+') ? userId?.replace('+', '') : userId;
  return await makeApiCall(`/foapi/market/getWatchlist?userId=${formattedUserId}`, 'GET', {}, {}, { cache: 'no-store' })
    .then((res) => {
      if (res?.status) {
        return processApiValues([res])[0];
      }
      return [];
    });
};

export const getWatchlistStocks = async (watchlistId) => {
  return await makeApiCall(`/foapi/market/getWatchlistStocks?watchlistId=${watchlistId}`, 'GET', {}, {}, { cache: 'no-store' })
    .then(res => {
      if (res?.status) {
        return processApiValues([res])[0];
      }
      return [];
    });
};

export const deleteFromWatchlist = async (watchlistId, symbol, currentTab, expiry_date) => {
  return await makeApiCall(`/foapi/market/deleteWatchlistStocks?watchlistId=${watchlistId}&exchangeSymbol=${symbol}${currentTab === 'futures' ? '&isfuture=1&expiry_date=' + expiry_date : ''}`, 'GET', {}, {}, { cache: 'no-store' })
    .then(res => {
      return res;
    });
};

export const deleteWatchlist = async (watchlistId) => {
  return await makeApiCall(`/foapi/market/deleteWatchlist?watchlistId=${watchlistId}`, 'GET', {}, {}, { cache: 'no-store' })
    .then(res => {
      return res;
    });
};

export const saveWatchlist = async (userId, watchlist) => {
  const formattedUserId = userId.startsWith('+') ? userId?.replace('+', '') : userId;
  const body = { userId : formattedUserId, watchlist };
  return await makeApiCall(`/foapi/market/saveWatchlist`, 'POST', body, {}, { cache: 'no-store' })
    .then(res => {
      if (res?.status) {
        return processApiValues([res])[0];
      }
      return [];
    });
};

export const saveWatchlistStock = async (watchlist, stock, listName) => {
  const exchangeMapping = {
    indices: 3,
    commodities: 6,
    bonds: 5,
    stocks: 1,
    currency: 4,
    stocksBse: 2
  };
  const body = {
    watchlist,
    stocks: stock?.isin || stock?.entityId || stock?.exchangeSymbol || stock?.exchange_symbol || stock?.name,
    exchangeId: listName !== 'futures' ? listName === 'indices' ? stock?.exchangeId : listName === 'stocks' ? !!stock?.nse?.exchangeSymbol ? exchangeMapping[listName] : exchangeMapping['stocksBse'] : exchangeMapping[listName] : undefined,
    isFuture: listName === 'futures' ? 1 : 0,
    expiry_date: listName === 'futures' ? stock?.expiry_date : undefined
  };
  return await makeApiCall(`/foapi/market/saveWatchlistStock`, 'POST', body, {}, { cache: 'no-store' })
    .then(res => {
      if (res?.status) {
        return processApiValues([res])[0];
      }
      return [];
    });
};

export const searchStocks = async (params, currentTab) => {
  return await makeApiCall(`/foapi/market/searchStocks${params}${currentTab === 'stocks' ? '&instrumentId=2' : currentTab === 'indices' ? '&instrumentId=1' : ''}`, 'GET', {}, {}, { cache: 'no-store' })
    .then(res => {
      if (res?.status) {
        return processApiValues([res])[0];
      }
      return [];
    });
};

export const fetchStocksFocusData = async (stock) => {
  const url = '/foapi/market/getStockInsight?limit=6';
  const mapping = {
    NSE: 'NIFTY%20500',
    BSE: 'BSE%20-%20500',
  };
  const allDataCalls = [
    await makeApiCall(`${url}&group=${mapping[stock]}&type=0`),
    await makeApiCall(`${url}&group=${mapping[stock]}&type=1`),
    await makeApiCall(`${url}&group=${mapping[stock]}&type=2`)
  ];

  return Promise.all(allDataCalls)
    .then(res => {
      if (res?.length > 0) {
        return processApiValues([res[0], res[1], res[2]]);
      }
      return [];
    });
};

// export const getFirebaseUserDetails = async (userId) => {
//   return await makeApiCall(`/watchlist/get-user-details?userId=${userId}`);
// };
//
// export const pushToFirebase = (setter, body, value = '') => {
//   return makeApiCall(`/watchlist/update-user-details`, 'POST', body)
//     .then(res => {
//       if (res?.status) {
//         if (value === 'manual') {
//           setter(false);
//         } else {
//           setter(true);
//         }
//       }
//       return res?.status;
//     })
//     .catch(err => {
//       console.log('Error in pushing to firebase', err);
//       return false;
//     });
// };

export const getStockStories = (tag, id) => {
  return makeApiCall(`/api/v1/stories?tag=${tag}&limit=20&fields=headline,slug,id,hero-image-s3-key,last-published-at,sections,access-level-value&sort=latest-published&exclude-section-id=${id}`);
};

export const getResearchReports = (tag, id) => {
  return makeApiCall(`/api/v1/advanced-search?section-id=${id}&tag-name=${tag}&limit=20&fields=headline,slug,id,hero-image-s3-key,last-published-at,sections,access-level-value,author-name&sort=latest-published`);
};

export const getStockDetails = (mojoId) => {
  return makeApiCall(`/next/feapi/stock/stock-details/${mojoId}`);
};
